import './UnifiedIdentity.css'

const features = [
  {
    title: 'Single Sign-On',
    description: 'Log in once and move freely between modules. Your session, your data, your context — always intact.',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M15 3h4a2 2 0 012 2v14a2 2 0 01-2 2h-4"/>
        <polyline points="10 17 15 12 10 7"/>
        <line x1="15" y1="12" x2="3" y2="12"/>
      </svg>
    ),
  },
  {
    title: 'Unified Billing',
    description: 'One invoice for all Hubthrill services. Clear line items. No surprise charges from disconnected systems.',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <rect x="1" y="4" width="22" height="16" rx="2"/>
        <line x1="1" y1="10" x2="23" y2="10"/>
      </svg>
    ),
  },
  {
    title: 'Centralized Access Control',
    description: 'Add team members, assign roles, and control who sees what — across every module — from one admin panel.',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/>
        <circle cx="9" cy="7" r="4"/>
        <path d="M23 21v-2a4 4 0 00-3-3.87"/>
        <path d="M16 3.13a4 4 0 010 7.75"/>
      </svg>
    ),
  },
  {
    title: 'Secure by Default',
    description: 'Two-factor authentication, session management, and audit logs built into every account.',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
      </svg>
    ),
  },
]

function UnifiedIdentity() {
  return (
    <section className="unified-identity section">
      <div className="container">
        <div className="identity-grid">
          <div className="identity-content">
            <span className="section-label">Unified identity</span>
            <h2 className="section-title">
              One login.<br />
              <span className="gradient-text">Full control.</span>
            </h2>
            <p className="identity-description">
              Your Hubthrill account is your business identity. With a single set 
              of credentials, you access payments, accounting, and infrastructure — 
              no password fatigue, no context switching.
            </p>
            <p className="identity-subtext">
              Invite your team once. Set permissions once. Manage billing in one place.
            </p>
            <a href="/signup" className="btn btn-primary btn-lg">
              Create your Hubthrill account
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M5 12h14M12 5l7 7-7 7"/>
              </svg>
            </a>
          </div>

          <div className="identity-features">
            {features.map((feature, index) => (
              <div key={index} className="identity-feature">
                <div className="feature-icon">
                  {feature.icon}
                </div>
                <div className="feature-content">
                  <h3 className="feature-title">{feature.title}</h3>
                  <p className="feature-description">{feature.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default UnifiedIdentity
